import { ICategoriaAtendimento } from "../../../../Interfaces/Geral/GestaoDeCadastro/CategoriaAtendimento/CategoriaAtendimentoInterface";
import Axios from "../../../Config/API";
import Service from "../../../Service";

export async function ListarCategoriasAtendimentosPaiService() {
    return Service(
        Axios.get<Array<ICategoriaAtendimento>>(
            `/home/categoriaatendimento/listarcategoriaatendimentopai`
        )
    );
}

export async function ListarCategoriasAtendimentosFilhoService(
    idCategoriaPai: number
) {
    return Service(
        Axios.get<Array<ICategoriaAtendimento>>(
            `/home/categoriaatendimento/listarcategoriaatendimentofilho?idCategoriaAtendimentoPai=${idCategoriaPai}`
        )
    );
}

export async function ListarCategoriasAtendimentoService(idTipoCaso: number) {
    return Service(
        Axios.get<Array<ICategoriaAtendimento>>(
            `/home/categoriaatendimento/listarcategoriaatendimentogeral?ID_TIPO_CASO=${idTipoCaso}`
        )
    );
}
